export const isKeyInObject = <T extends Record<string, unknown>>(
  key: string | number | symbol,
  obj: T,
): key is keyof T => key in obj;
